import type { UseQueryResult } from 'react-query';
import { useQuery } from 'react-query';
import { getAllUserAttributes } from './api';
import type { UserAttribute, UserAttributeOptionType } from './model/UserAttribute';
import { UserAttributeKind } from './model/UserAttribute';

const USER_ATTRIBUTE_KNOWN_QUERY_KEY = 'user-attributes-known';

export const useKnownUserAttributes = (
  siteId?: number,
  userAttributesEnabled?: boolean,
): UseQueryResult<Map<string, UserAttributeOptionType>, Error> => {
  return useQuery<UserAttribute[], Error, Map<string, UserAttributeOptionType>>(
    `${USER_ATTRIBUTE_KNOWN_QUERY_KEY}-${siteId}`,
    // Thanks to the "enabled" prop below,
    // the fetch method will only run when siteId becomes defined
    () => getAllUserAttributes(siteId as number),
    {
      enabled: siteId != null && userAttributesEnabled === true,
      select: (list) => {
        return new Map(
          list
            .filter((item) => item.datatype !== UserAttributeKind.Unknown)
            .map((item) => {
              return [item.name, { kind: item.datatype, name: item.name }];
            }),
        );
      },
      retry: 1,
      staleTime: Infinity,
      refetchOnWindowFocus: false,
    },
  );
};
